import Dropdown from "react-bootstrap/Dropdown";

const DropdownItem = (props) => {
  const { onClickAction, translation, disabled = false } = props || {};
  return (
    <Dropdown.Item
      style={{
              color: disabled ? "#a0a0a0" : "white",
              cursor: disabled ? "not-allowed" : "pointer",
            }}
      onClick={onClickAction}
      disabled={disabled}
    >
      {translation}
    </Dropdown.Item>
  );
};

export default DropdownItem;
